import DataTableWidget from './DataTableWidget-compose';

export default DataTableWidget;
